import { array, boolean, dateTime, defineAction, enumerated, number, object, string } from '~/prix'
import entrepreneurAgentRequestAction from './entrepreneurAgentRequest.action.json'

const entrepreneurAgentRequestDefinition = defineAction({
  ...entrepreneurAgentRequestAction,
  userActivityLogInput: 'omit' as const,
  input: object({
    entrepreneurCpf: string(),
    legalEntityCnpj: string().isOptional(),
    latitude: number(),
    longitude: number(),
    accuracy: number().isOptional(),
    startNewSearch: boolean().isOptional(),
    address: object({
      displayAddress: string().isOptional(),
      postalCode: string().isOptional(),
      stateAbbreviation: string().isOptional(),
      city: string().isOptional(),
      cityId: number().isOptional(),
      neighborhood: string().isOptional(),
      street: string().isOptional(),
      number: string().isOptional(),
      complement: string().isOptional(),
      reference: string().isOptional(),
    }).isOptional(),
    companyName: string().isOptional(),
    contactPhone: string().isOptional(),
    serviceReason: string().isOptional(),
    entrepreneurName: string().isOptional(),
    entrepreneurPhoto: string().isOptional(),
  }),
  output: object({
    state: enumerated({
      searchingAgents: 'searching_agents',
      agentAccepted: 'agent_accepted',
      agentArrived: 'agent_arrived',
      inAttendance: 'in_attendance',
      allAgentsRefused: 'all_agents_refused',
      noAgentsAvailable: 'no_agents_available',
      done: 'done',
      canceled: 'canceled',
    }),
    created: boolean().isOptional(),
    pendingCount: number(),
    refusedCount: number(),
    agentsPreview: array(
      object({
        cpf: string(),
        latitude: number().isOptional(),
        longitude: number().isOptional(),
        accuracy: number().isOptional(),
        lastGeolocationUpdate: dateTime().isOptional(),
        geodesicDistanceMeters: number().isOptional(),
        drivingDistanceMeters: number().isOptional(),
        drivingDurationSeconds: number().isOptional(),
        status: enumerated({
          waitingAnswer: 'waiting_answer',
          refused: 'refused',
          accepted: 'accepted',
        }),
      }),
    ),
    warnings: array(
      object({
        message: string(),
      }),
    ).isOptional(),
  }),
})

export default entrepreneurAgentRequestDefinition
